import React, { useRef } from "react";
import { useAccountModel } from "./accountModel";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { AppDrawer } from "@/components/YhDrawer";
import { YhForm } from "@/components/YhFormBox";
import { UserTypeEnum } from "@/types/FmsEnums";
import { accountService, creditFlagDs } from "../../../../AccountService";
import { message } from "antd";
import { useDetailModel } from "../detailModel";
import { useLockFn } from "ahooks";

export const RechargeDrawer = () => {
    const {
        orgDs,
        beDs,
        payMethodDs,
        customer
    } = useDetailModel(model => [
        model.customer,
        model.orgDs,
        model.beDs,
    ]);
    const {
        selectedData,
        rechargeDrawerVisible,
        setRechargeDrawerVisible,
        onReset,
    } = useAccountModel(model => [model.rechargeDrawerVisible]);
    const formRef = useRef<IYhFormRef>();

    const formConfig: IYhForm = {
        formRef,
        labelCol: { span: 6 },
        disabled: false,
        formValues: { ...selectedData },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户",
                fieldName: "code",
                disable: true,
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "账户",
                fieldName: "name",
                disable: true,
                span: 24,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "授信类型",
                fieldName: "creditFlag",
                disable: true,
                span: 24,
                ds: creditFlagDs(),
            },
            {
                type: FormItemTypeEnum.TreeSelect,
                fieldLabel: "机构",
                fieldName: "orgCode",
                disable: true,
                span: 24,
                treeDs: orgDs
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "实体",
                fieldName: "beCode",
                disable: true,
                span: 24,
                ds: beDs
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "剩余金额",
                fieldName: "remainingAmount",
                disable: true,
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "充值金额",
                fieldName: "rechargeAmount",
                span: 24,
                rules: [{
                    required: true,
                    pattern: new RegExp(/^[+]?(\d+)$|^[+]?(\d+\.\d+)$/),
                    message: "输入不能为空且大于等于0的数字!"
                }],
            },
            {
                type: FormItemTypeEnum.TreeSelect,
                fieldLabel: "支付方式",
                fieldName: "payMethodCode",
                span: 24,
                treeData: payMethodDs,
                rules: [{
                    required: true,
                    message: "授信类型不能为空"
                }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "收款人",
                fieldName: "operator",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "remark",
                span: 24,
            },
        ]
    };

    const onOk = useLockFn(async () => {
        try {
            let formData = await formRef.current?.validateFields();
            if (formData) {
                const reqData = {
                    ...formData,
                    accountCode: formData.code,
                    partnerTypeCode: UserTypeEnum.CUSTOMER,
                    partnerCode: customer.code,
                    note: formData.remark
                };
                let insertRet = await accountService.recharge(reqData);
                if (insertRet.success) {
                    message.success("充值成功!");
                    onReset();
                    setRechargeDrawerVisible(false);
                } else {
                    message.error("充值失败!" + insertRet.retMsg);
                }
            }
        } catch (e) {
            console.log("数据校验失败");
        }
    })
    const onCancel = () => {
        setRechargeDrawerVisible(false);
    }
    return (
        <AppDrawer
            {...{
                title: "账户充值",
                visible: rechargeDrawerVisible,
                onOk,
                onCancel,
                showFooter: true
            }}
        >
            <YhForm {...formConfig} />
        </AppDrawer>
    )
}
